import classNames from "classnames";
import React, { FC } from "react";
import styles from "./tableStyle.module.css";

type TableBodyProps = {
  rowHeight?: "lg" | "md" | "sm" | "xs";
  alternateRowColor?: boolean;
  style?: any;
};

const TableBody: FC<TableBodyProps> = ({
  children,
  rowHeight = "md",
  alternateRowColor = true,
  style,
}) => {
  const heights = {
    lg: styles.rowHeightLg,
    md: styles.rowHeightMd,
    sm: styles.rowHeightSm,
    xs: styles.rowHeightXs,
  };

  return (
    <tbody
      className={classNames(
        alternateRowColor && styles.alternateRowColor,
        heights[rowHeight]
      )}
      style={style}
    >
      {children}
    </tbody>
  );
};

export default TableBody;
